import { createApi } from '@reduxjs/toolkit/query/react';
import { GenericInvitationDto, UpdateInvitationProps } from '@app/store/invitation/types';
import { customBaseQueryWithReauth } from '../refresh/customBaseQuery';

export const INVITATION_PATH = 'invitation';
const GET_INVITATION_TAG = 'GET_INVITATION_TAG';

export const invitationApi = createApi({
    reducerPath: INVITATION_PATH,
    refetchOnMountOrArgChange: true,
    refetchOnReconnect: true,
    refetchOnFocus: true,
    tagTypes: [GET_INVITATION_TAG], // <-- add tagTypes
    keepUnusedDataFor: 0,
    baseQuery: customBaseQueryWithReauth,
    endpoints: (builder) => ({
        updateAllInvitation: builder.mutation<any, UpdateInvitationProps>({
            query: (requestBody) => ({
                url: `/organizations/${requestBody.organizationId}/invitations/${requestBody.invitationToken}/all`,
                method: 'POST',
                params: {
                    invitationStatus: requestBody.invitationStatus
                }
            }),
            invalidatesTags: [GET_INVITATION_TAG]
        }),
        getAllInvitationsOfAUser: builder.query<Array<GenericInvitationDto>, void>({
            query: () => ({
                url: '/user/invitations',
                method: 'GET'
            }),
            providesTags: [GET_INVITATION_TAG]
        }),
        hasPendingInvitations: builder.query<boolean, void>({
            query: () => ({
                url: `user/has-pending-invitations`,
                method: 'GET'
            })
        })
    })
});

export const { useUpdateAllInvitationMutation, useLazyGetAllInvitationsOfAUserQuery, useHasPendingInvitationsQuery, useLazyHasPendingInvitationsQuery } = invitationApi;
